import {User} from './user';
import {DocumentTemplate} from './documentTemplate';
import {JobRole} from './jobRole';
import {DocumentTemplateSolution} from './documentTemplateSolution';

export interface UserJobRoleInterface {
  id: string;
  name: string;
  userId: string;
  jobRoleId?: string;
  deadline?: boolean;
  deadlineDate?: string;
  documentTemplateId: string;
  status?: string;
  notes?: string;
  submittedAt?: string;
  reviewedAt?: string;
  reviewedById?: string;
  createdAt: string;
  updatedAt: string;
  attachment?: any;
  user?: User;
  documentTemplate?: {
    id: string;
    name: string;
    description: string;
  };
  reviewedBy?: {
    id: string;
    name: string;
  };
  documentTemplateSolutionAttributes?: {
    documentTemplateId: string;
    snapshot: DocumentTemplate;
  };
  documentTemplateSolution?: DocumentTemplateSolution;
  pendingReviewers?: User[];
  jobRole?: JobRole;
}

export class UserJobRole implements UserJobRoleInterface {
  id: string;
  userId: string;
  name: string;
  deadline?: boolean;
  deadlineDate?: string;
  user?: User;
  jobRoleId?: string;
  documentTemplateId: string;
  status?: string;
  notes?: string;
  submittedAt?: string;
  reviewedAt?: string;
  reviewedById?: string;
  createdAt: string;
  updatedAt: string;
  attachment?: any;
  documentTemplate?: {
    id: string;
    name: string;
    description: string;
  };
  reviewedBy?: {
    id: string;
    name: string;
  };
  documentTemplateSolutionAttributes?: {
    documentTemplateId: string;
    snapshot: DocumentTemplate;
  };
  documentTemplateSolution?: DocumentTemplateSolution;
  pendingReviewers?: User[];
  jobRole?: JobRole;

  constructor(data: Partial<UserJobRoleInterface>) {
    this.id = data.id!;
    this.userId = data.userId!;
    this.name = data.name!;
    this.jobRoleId = data.jobRoleId;
    this.deadline = data.deadline;
    this.deadlineDate = data.deadlineDate;
    this.user = data.user;
    this.documentTemplateId = data.documentTemplateId!;
    this.status = data.status;
    this.notes = data.notes;
    this.submittedAt = data.submittedAt;
    this.reviewedAt = data.reviewedAt;
    this.reviewedById = data.reviewedById;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.attachment = data.attachment;
    this.documentTemplate = data.documentTemplate;
    this.reviewedBy = data.reviewedBy;
    this.documentTemplateSolutionAttributes =
      data.documentTemplateSolutionAttributes;
    this.documentTemplateSolution = data.documentTemplateSolution;
    this.pendingReviewers = data.pendingReviewers;
    this.jobRole = data.jobRole;
  }

  toJson(): Partial<UserJobRoleInterface> {
    return {
      id: this.id,
      userId: this.userId,
      user: this.user,
      name: this.name,
      jobRoleId: this.jobRoleId,
      documentTemplateId: this.documentTemplateId,
      deadline: this.deadline,
      deadlineDate: this.deadlineDate,
      documentTemplateSolutionAttributes:
        this.documentTemplateSolutionAttributes,
      documentTemplateSolution: this.documentTemplateSolution,
      pendingReviewers: this.pendingReviewers,
      jobRole: this.jobRole,
    };
  }
}
